import { CSSProperties } from 'react'
import styled from 'styled-components'

interface ProgressCircleWrapperProps {
  style?: CSSProperties
}

export const ProgressCircleWrapper = styled.div<ProgressCircleWrapperProps>`
  svg {
    g {
      transform-origin: center center;
      transform-box: fill-box;
    }
  }
`
